<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.notifications.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.notifications.notificationOpen.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.notifications.notificationOpen.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic1Name" />
    <p>
      {{ $t('documentation.texts.notifications.notificationOpen.paragraph2') }}
    </p>
    <v-img style="width: 100%; max-width: 1500px" contain :src="pic2Name" />
    <p>
      {{ $t('documentation.texts.notifications.notificationOpen.paragraph3') }}
    </p>
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/notifications/' +
        this.$t(
          'documentation.texts.notifications.notificationOpen.picOpenAdvice'
        ) +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/notifications/' +
        this.$t(
          'documentation.texts.notifications.notificationOpen.picOpened'
        ) +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
